<template>
  <a-modal width="45%" :title="titlePrefix" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
    :confirm-loading="confirmLoading" @ok="onSubmit" @cancel="onClose">
    <a-form ref="ruleForm" layout="vertical" :model="form" :rules="rules" @submit="onSubmit">
      <!--可编辑区域 start-->
      <div class="hidden">
        <a-form-item label="id" name="id">
          <a-input v-model:value="form.id" />
        </a-form-item>
      </div>
      <a-form-item label="学校名称" name="schoolName">
        <a-input v-model:value="form.schoolName" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="所学专业" name="major">
        <DictSelect v-model:value="form.major" :dict-name="education.MAJOR" placeholder="请选择" />
      </a-form-item>
      <a-form-item label="所获学历" name="educationBackground">
        <DictSelect v-model:value="form.educationBackground" :dict-name="education.EDUCATION_BACKGROUND" placeholder="请选择" />
      </a-form-item>
      <a-form-item label="在校时间" name="workTime">
        <range-picker style="width: 100%" v-model:startDate="form.entryTime" v-model:endDate="form.graduationTime" />
      </a-form-item>
      <!--可编辑区域 end-->
    </a-form>
  </a-modal>
</template>
<script>
import dataCheck from "@/utils/dataCheck";
import { formMixin } from "@/mixins";
import { eduExpriseInfo } from "@/api/educationService";
import DictSelect from "@/components/other/DictSelect";
import { education, dateFormat } from "@/config/variableConfig";

export default {
  name: "UserModal",
  components: { DictSelect},
  mixins: [formMixin],
  data() {
    return {
      education,
      dateFormat,
      form: {
        id: null,
      },
      rules: {
        educationBackground: [dataCheck.required({})],
        entryTime: [],
        graduationTime: [],
        major: [dataCheck.required({})],
        schoolName: [dataCheck.required({})],
        id: [],
      },
      submitUrl: eduExpriseInfo.saveupdate
    }
  },
}
</script>
<style scoped lang="less"></style>
